function nullToEmpty(s: string | null | undefined): string {
    return s ? s : "";
}

export { nullToEmpty };
